"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _SaveCustomViewModal = _interopRequireDefault(require("./SaveCustomViewModal"));

var _DeleteCustomViewModal = _interopRequireDefault(require("./DeleteCustomViewModal"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var createNewCustomView = 'Create new custom view';
var updateExistingCustomView = 'Save changes to the current view';

var CustomViewActions = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CustomViewActions, _Component);

  var _super = _createSuper(CustomViewActions);

  function CustomViewActions(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CustomViewActions);
    _this = _super.call(this, props); // eslint-disable-next-line react/state-in-constructor

    _this.state = {
      showSaveModal: false,
      showDeleteModal: false,
      radioInput: props.isCustomView ? updateExistingCustomView : createNewCustomView,
      inputName: ''
    };
    _this.onSaveViewClicked = _this.onSaveViewClicked.bind((0, _assertThisInitialized2.default)(_this));
    _this.onDeleteViewClicked = _this.onDeleteViewClicked.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeSaveModal = _this.closeSaveModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeDeleteModal = _this.closeDeleteModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCustomViewNameChanged = _this.onCustomViewNameChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onRadioButtonChanged = _this.onRadioButtonChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSaveCustomView = _this.onSaveCustomView.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CustomViewActions, [{
    key: "onSaveViewClicked",
    value: function onSaveViewClicked() {
      this.setState({
        showSaveModal: true
      });
    }
  }, {
    key: "onDeleteViewClicked",
    value: function onDeleteViewClicked() {
      this.setState({
        showDeleteModal: true
      });
    }
  }, {
    key: "closeSaveModal",
    value: function closeSaveModal() {
      this.setState({
        showSaveModal: false
      });
    }
  }, {
    key: "closeDeleteModal",
    value: function closeDeleteModal() {
      this.setState({
        showDeleteModal: false
      });
    }
  }, {
    key: "onCustomViewNameChanged",
    value: function onCustomViewNameChanged(e) {
      this.setState({
        inputName: e.target.value
      });
    }
  }, {
    key: "onRadioButtonChanged",
    value: function onRadioButtonChanged(option) {
      this.setState({
        radioInput: option
      });
    }
  }, {
    key: "onSaveCustomView",
    value: function onSaveCustomView() {
      var _this$state = this.state,
          radioInput = _this$state.radioInput,
          inputName = _this$state.inputName;
      var onSaveCustomView = this.props.onSaveCustomView;
      onSaveCustomView(radioInput === createNewCustomView ? inputName : undefined);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isCustomView = _this$props.isCustomView,
          customViewName = _this$props.customViewName,
          onShareView = _this$props.onShareView,
          onDeleteCustomView = _this$props.onDeleteCustomView,
          errorMessage = _this$props.errorMessage;
      var _this$state2 = this.state,
          showSaveModal = _this$state2.showSaveModal,
          showDeleteModal = _this$state2.showDeleteModal,
          inputName = _this$state2.inputName,
          radioInput = _this$state2.radioInput;
      return (0, _preact.h)("div", {
        className: "overview__views-container"
      }, (0, _preact.h)("div", {
        className: "control-header__action-buttons"
      }, isCustomView && (0, _preact.h)(_buttonControl.default, {
        onClick: this.onDeleteViewClicked,
        title: "Delete",
        variant: "warning",
        class: "qa-delete-view",
        newStyle: true,
        size: "medium"
      }), (0, _preact.h)(_Tooltip.default, {
        trigger: (0, _preact.h)(_buttonControl.default, {
          onClick: onShareView,
          title: "Share view",
          class: "qa-share-view",
          newStyle: true,
          size: "medium"
        }),
        tooltipMessage: "Share current filter and column settings with your team mates via URL",
        qaClasses: "qa-save-view-tooltip",
        withArrow: true,
        position: "center"
      }), (0, _preact.h)(_buttonControl.default, {
        onClick: this.onSaveViewClicked,
        title: "Save view",
        variant: "success",
        class: "save-view",
        newStyle: true,
        size: "medium"
      })), (0, _preact.h)(_SaveCustomViewModal.default, {
        customViewName: inputName,
        customViewRadioInput: radioInput,
        isCustomView: isCustomView,
        onClose: this.closeSaveModal,
        onCustomViewNameChanged: function onCustomViewNameChanged(e) {
          return _this2.onCustomViewNameChanged(e);
        },
        onRadioButtonChanged: function onRadioButtonChanged(option) {
          return _this2.onRadioButtonChanged(option);
        },
        onSaveCustomView: this.onSaveCustomView,
        radioOptions: [updateExistingCustomView, createNewCustomView],
        showModal: showSaveModal,
        errorMessage: errorMessage
      }), (0, _preact.h)(_DeleteCustomViewModal.default, {
        showModal: showDeleteModal,
        customViewName: customViewName,
        onClose: this.closeDeleteModal,
        onDeleteCustomView: onDeleteCustomView
      }));
    }
  }]);
  return CustomViewActions;
}(_preact.Component);

var _default = CustomViewActions;
exports.default = _default;